import { LINKS_GET_LINKS_REQUEST } from "UserAuthorized/actionTypes";

export const getLinks = () => {
  return { type: LINKS_GET_LINKS_REQUEST };
};
